/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTransmitter: {
  name: 'transmitter';
  data: string;
} = {
  name: 'transmitter',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 2a1 1 0 0 1 1 1v3h5a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1V3a1 1 0 0 1 1-1Zm6 10V8H8v4h8Zm-8 2h8v6H8v-6Zm7 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
